(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-feature-outfit"] && !Shopify.designMode) return;
  try {
    (function () {
    var TOP_COLLECTION_URL = '/collections/top-wear/products.json?limit=250';
    var BOTTOM_COLLECTION_URL = '/collections/bottom-wear/products.json?limit=250';
    var PROXY_URL = 'https://bliss-tryon-proxy.vercel.app/api/tryon';
    var FEEDBACK_URL = 'https://bliss-tryon-proxy.vercel.app/api/feedback';
    var HEIC2ANY_URL = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
    var MAX_UPLOAD_DIM = 1440;
    var SHARED_PHOTO_KEY = 'blissAiFeaturesPhoto';

    function id(name) { return document.getElementById(name); }

    var els = {
      searchTop: id('afs2SearchTop'),
      listTop: id('afs2ListTop'),
      backToTop: id('afs2BackToTop'),
      searchBottom: id('afs2SearchBottom'),
      listBottom: id('afs2ListBottom'),
      backToBottom: id('afs2BackToBottom'),
      sizePreviewTop: id('afs2SizePreviewTop'),
      sizeOptionsTop: id('afs2SizeOptionsTop'),
      sizePreviewBottom: id('afs2SizePreviewBottom'),
      sizeOptionsBottom: id('afs2SizeOptionsBottom'),
      sizesContinueBtn: id('afs2SizesContinueBtn'),
      consentBackBtn: id('afs2ConsentBackBtn'),
      reuseBlock: id('afs2ReuseBlock'),
      reuseThumb: id('afs2ReuseThumb'),
      reuseUseBtn: id('afs2ReuseUseBtn'),
      reuseNewBtn: id('afs2ReuseNewBtn'),
      newPhotoBlock: id('afs2NewPhotoBlock'),
      consentCheck: id('afs2ConsentCheck'),
      startBtn: id('afs2StartBtn'),
      galleryBtn: id('afs2GalleryBtn'),
      galleryBtn2: id('afs2GalleryBtn2'),
      galleryInput: id('afs2GalleryInput'),
      galleryContinueBtn: id('afs2GalleryContinueBtn'),
      galleryTipBackBtn: id('afs2GalleryTipBackBtn'),
      video: id('afs2Video'),
      switchBtn: id('afs2SwitchBtn'),
      captureBtn: id('afs2CaptureBtn'),
      cancelBtn: id('afs2CancelBtn'),
      capturedCanvas: id('afs2CapturedCanvas'),
      retakeBtn: id('afs2RetakeBtn'),
      generateBtn: id('afs2GenerateBtn'),
      generatingText: id('afs2GeneratingText'),
      resultImg: id('afs2ResultImg'),
      addToCartBtn: id('afs2AddToCartBtn'),
      cartMsg: id('afs2CartMsg'),
      downloadBtn: id('afs2DownloadBtn'),
      feedbackRow: id('afs2FeedbackRow'),
      starRating: id('afs2StarRating'),
      feedbackThanks: id('afs2FeedbackThanks'),
      retakeResultBtn: id('afs2RetakeResultBtn'),
      startOverBtn: id('afs2StartOverBtn'),
      errorText: id('afs2ErrorText'),
      errorRetryBtn: id('afs2ErrorRetryBtn'),
      states: {
        pickTop: id('afs2StatePickTop'),
        pickBottom: id('afs2StatePickBottom'),
        sizes: id('afs2StateSizes'),
        consent: id('afs2StateConsent'),
        galleryTip: id('afs2StateGalleryTip'),
        live: id('afs2StateLive'),
        captured: id('afs2StateCaptured'),
        generating: id('afs2StateGenerating'),
        result: id('afs2StateResult'),
        error: id('afs2StateError'),
      }
    };

    if (!els.searchTop) return; // snippet not on this page

    function showState(name) {
      Object.keys(els.states).forEach(function (k) { els.states[k].hidden = (k !== name); });
    }

    function sharedPhoto() { try { return sessionStorage.getItem(SHARED_PHOTO_KEY); } catch (e) { return null; } }
    function saveSharedPhoto(dataUrl) { try { sessionStorage.setItem(SHARED_PHOTO_KEY, dataUrl); } catch (e) {} }

    var topProducts = [];
    var bottomProducts = [];
    var selectedTop = null, selectedTopVariant = null;
    var selectedBottom = null, selectedBottomVariant = null;
    var currentStream = null;
    var currentFacingMode = 'user';
    var availableCameraCount = 1;
    var lastErrorRetryState = 'pickTop';
    var lastSourceWasGallery = false;
    var heicFallbackAttempted = false;
    var preGalleryTipState = 'consent';
    var lastGenerationElapsedMs = null;
    var feedbackSubmitted = false;
    var currentSessionId = null;
    var lastInputImageDataUrl = null;
    var lastOutputImageDataUrl = null;
    var secondPassRetried = false;

    function productImageUrl(product) {
      var src = product.images && product.images[0] && product.images[0].src;
      if (!src) return '';
      if (src.indexOf('://') === -1) src = 'https:' + src;
      return src;
    }

    function renderList(container, products, filterText, onPick) {
      var q = (filterText || '').trim().toLowerCase();
      var filtered = !q ? products : products.filter(function (p) { return p.title.toLowerCase().indexOf(q) !== -1; });
      container.innerHTML = '';
      if (!filtered.length) {
        var empty = document.createElement('p');
        empty.className = 'afs2-empty-text';
        empty.textContent = 'No products found.';
        container.appendChild(empty);
        return;
      }
      filtered.slice(0, 60).forEach(function (product) {
        var item = document.createElement('div');
        item.className = 'afs2-product-item';
        var img = document.createElement('img');
        img.src = productImageUrl(product);
        img.alt = product.title;
        img.loading = 'lazy';
        var info = document.createElement('div');
        info.className = 'afs2-product-item-info';
        var title = document.createElement('span');
        title.className = 'afs2-product-item-title';
        title.textContent = product.title;
        var price = document.createElement('span');
        price.className = 'afs2-product-item-price';
        var firstVariant = product.variants && product.variants[0];
        price.textContent = firstVariant ? ('Tk ' + firstVariant.price) : '';
        info.appendChild(title);
        info.appendChild(price);
        item.appendChild(img);
        item.appendChild(info);
        item.addEventListener('click', function () { onPick(product); });
        container.appendChild(item);
      });
    }

    function loadCollection(url, targetArraySetter, container) {
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.products || []).filter(function (p) { return p.images && p.images.length; });
          targetArraySetter(products);
          renderList(container, products, '', container === els.listTop ? pickTop : pickBottom);
        })
        .catch(function () {
          container.innerHTML = '<p class="afs2-empty-text">Could not load products. Please refresh and try again.</p>';
        });
    }

    function pickTop(product) {
      selectedTop = product;
      selectedTopVariant = null;
      showState('pickBottom');
    }
    function pickBottom(product) {
      selectedBottom = product;
      selectedBottomVariant = null;
      buildSizeBlock(els.sizePreviewTop, els.sizeOptionsTop, selectedTop, function (v) { selectedTopVariant = v; checkSizesReady(); });
      buildSizeBlock(els.sizePreviewBottom, els.sizeOptionsBottom, selectedBottom, function (v) { selectedBottomVariant = v; checkSizesReady(); });
      els.sizesContinueBtn.disabled = true;
      showState('sizes');
    }

    function buildSizeBlock(previewEl, optionsEl, product, onSelect) {
      previewEl.innerHTML = '';
      var img = document.createElement('img');
      img.src = productImageUrl(product);
      img.alt = product.title;
      var infoWrap = document.createElement('div');
      var titleEl = document.createElement('div');
      titleEl.className = 'afs2-size-preview-title';
      titleEl.textContent = product.title;
      var priceEl = document.createElement('div');
      priceEl.className = 'afs2-size-preview-price';
      var firstVariant = product.variants && product.variants[0];
      priceEl.textContent = firstVariant ? ('Tk ' + firstVariant.price) : '';
      infoWrap.appendChild(titleEl);
      infoWrap.appendChild(priceEl);
      previewEl.appendChild(img);
      previewEl.appendChild(infoWrap);

      optionsEl.innerHTML = '';
      (product.variants || []).forEach(function (variant) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'afs2-size-btn';
        btn.textContent = variant.title;
        btn.setAttribute('aria-pressed', 'false');
        if (!variant.available) btn.disabled = true;
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          Array.prototype.forEach.call(optionsEl.querySelectorAll('.afs2-size-btn'), function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          onSelect(variant);
        });
        optionsEl.appendChild(btn);
      });
    }

    function checkSizesReady() {
      els.sizesContinueBtn.disabled = !(selectedTopVariant && selectedBottomVariant);
    }

    els.backToTop.addEventListener('click', function () { showState('pickTop'); });
    els.backToBottom.addEventListener('click', function () { showState('pickBottom'); });
    els.sizesContinueBtn.addEventListener('click', function () {
      if (!selectedTopVariant || !selectedBottomVariant) return;
      var existing = sharedPhoto();
      if (existing) {
        els.reuseBlock.hidden = false;
        els.reuseThumb.src = existing;
        els.newPhotoBlock.hidden = true;
      } else {
        els.reuseBlock.hidden = true;
        els.newPhotoBlock.hidden = false;
      }
      showState('consent');
      els.consentCheck.checked = false;
      els.startBtn.disabled = true;
      els.galleryBtn.disabled = true;
    });
    els.consentBackBtn.addEventListener('click', function () { showState('sizes'); });
    els.reuseUseBtn.addEventListener('click', function () {
      var img = new Image();
      img.onload = function () {
        var canvas = els.capturedCanvas;
        canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
        canvas.getContext('2d').drawImage(img, 0, 0);
        lastSourceWasGallery = true;
        showState('captured');
      };
      img.src = sharedPhoto();
    });
    els.reuseNewBtn.addEventListener('click', function () { els.reuseBlock.hidden = true; els.newPhotoBlock.hidden = false; });

    function resetFeedbackUI() {
      feedbackSubmitted = false;
      els.feedbackRow.hidden = false;
      els.feedbackThanks.hidden = true;
      els.cartMsg.hidden = true;
    }

    function makeSessionId() {
      return 'outfit-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    }

    function logSession() {
      fetch(FEEDBACK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: currentSessionId,
          garmentType: 'outfit',
          productHandle: selectedTop.handle + '+' + selectedBottom.handle,
          elapsedMs: lastGenerationElapsedMs,
          inputImage: lastInputImageDataUrl,
          outputImage: lastOutputImageDataUrl,
          sessionType: 'multi',
        }),
      }).catch(function () {});
    }

    function submitFeedback(rating) {
      if (feedbackSubmitted) return;
      feedbackSubmitted = true;
      els.feedbackRow.hidden = true;
      els.feedbackThanks.hidden = false;
      fetch(FEEDBACK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: currentSessionId,
          rating: rating,
          garmentType: 'outfit',
          productHandle: selectedTop.handle + '+' + selectedBottom.handle,
          elapsedMs: lastGenerationElapsedMs,
          sessionType: 'multi',
        }),
      }).catch(function () {});
    }

    function stopCamera() {
      if (currentStream) { currentStream.getTracks().forEach(function (t) { t.stop(); }); currentStream = null; }
    }

    function cameraErrorMessage(e) {
      if (e && e.name === 'NotAllowedError') return "Camera access was denied. You can allow it from your browser's site settings, or choose a photo from your gallery instead.";
      if (e && e.name === 'NotFoundError') return 'No camera was found on this device. You can choose a photo from your gallery instead.';
      return 'Could not access the camera (' + (e && e.message ? e.message : 'unknown error') + '). You can choose a photo from your gallery instead.';
    }

    function showError(msg, retryState) {
      stopCamera();
      els.errorText.textContent = msg;
      lastErrorRetryState = retryState || 'pickTop';
      showState('error');
    }

    function countCameras() {
      return navigator.mediaDevices.enumerateDevices().then(function (devices) {
        availableCameraCount = devices.filter(function (d) { return d.kind === 'videoinput'; }).length;
      }).catch(function () { availableCameraCount = 1; });
    }

    function startCamera(facingMode) {
      stopCamera();
      return navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: facingMode }, width: { ideal: 1280 }, height: { ideal: 1280 } },
        audio: false
      }).then(function (stream) {
        currentStream = stream;
        currentFacingMode = facingMode;
        els.video.srcObject = stream;
        els.video.style.transform = facingMode === 'user' ? 'scaleX(-1)' : 'none';
        return countCameras();
      }).then(function () {
        els.switchBtn.hidden = availableCameraCount < 2;
        showState('live');
      }).catch(function (e) { showError(cameraErrorMessage(e), 'consent'); });
    }

    function looksLikeHeic(file) {
      var name = (file.name || '').toLowerCase();
      var type = (file.type || '').toLowerCase();
      return type.indexOf('heic') !== -1 || type.indexOf('heif') !== -1 || name.endsWith('.heic') || name.endsWith('.heif');
    }

    function ensureHeic2any() {
      if (window.heic2any) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = HEIC2ANY_URL;
        s.onload = function () { resolve(); };
        s.onerror = function () { reject(new Error('Could not load photo converter')); };
        document.head.appendChild(s);
      });
    }

    function loadBlobIntoCanvas(blob) {
      var reader = new FileReader();
      reader.onload = function () {
        var img = new Image();
        img.onload = function () {
          stopCamera();
          var w = img.naturalWidth;
          var h = img.naturalHeight;
          if (w > MAX_UPLOAD_DIM || h > MAX_UPLOAD_DIM) {
            if (w >= h) { h = Math.round(h * MAX_UPLOAD_DIM / w); w = MAX_UPLOAD_DIM; }
            else { w = Math.round(w * MAX_UPLOAD_DIM / h); h = MAX_UPLOAD_DIM; }
          }
          var canvas = els.capturedCanvas;
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          lastSourceWasGallery = true;
          saveSharedPhoto(canvas.toDataURL('image/jpeg', 0.9));
          showState('captured');
        };
        img.onerror = function () { tryHeicFallback(blob); };
        img.src = reader.result;
      };
      reader.onerror = function () { showError('Could not read that file. Please try again.', 'consent'); };
      reader.readAsDataURL(blob);
    }

    function convertHeicAndLoad(file) {
      showState('generating');
      els.generatingText.textContent = 'Preparing your photo…';
      ensureHeic2any()
        .then(function () { return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 }); })
        .then(function (converted) { loadBlobIntoCanvas(Array.isArray(converted) ? converted[0] : converted); })
        .catch(function () { showError('This photo format (HEIC) could not be converted. Please try a different photo, or use the camera instead.', 'consent'); });
    }

    function tryHeicFallback(blob) {
      if (heicFallbackAttempted) { showError('Could not read that image. Please try a different photo.', 'consent'); return; }
      heicFallbackAttempted = true;
      convertHeicAndLoad(blob);
    }

    function processFile(file) {
      if (looksLikeHeic(file)) { convertHeicAndLoad(file); return; }
      loadBlobIntoCanvas(file);
    }

    function loadImageFromFile(file) {
      if (!file) return;
      var type = (file.type || '').toLowerCase();
      if (type.indexOf('image/') !== 0 && !looksLikeHeic(file)) { showError('Please choose an image file.', 'consent'); return; }
      heicFallbackAttempted = false;
      processFile(file);
    }

    els.consentCheck.addEventListener('change', function () {
      els.startBtn.disabled = !els.consentCheck.checked;
      els.galleryBtn.disabled = !els.consentCheck.checked;
    });
    els.startBtn.addEventListener('click', function () { lastSourceWasGallery = false; startCamera(currentFacingMode); });

    function openGalleryTip(fromState) {
      preGalleryTipState = fromState;
      if (fromState === 'live') stopCamera();
      showState('galleryTip');
    }
    els.galleryBtn.addEventListener('click', function () { openGalleryTip('consent'); });
    els.galleryBtn2.addEventListener('click', function () { openGalleryTip('live'); });
    els.galleryContinueBtn.addEventListener('click', function () { els.galleryInput.click(); });
    els.galleryTipBackBtn.addEventListener('click', function () {
      if (preGalleryTipState === 'live') startCamera(currentFacingMode); else showState('consent');
    });
    els.galleryInput.addEventListener('change', function (e) {
      var file = e.target.files && e.target.files[0];
      loadImageFromFile(file);
      els.galleryInput.value = '';
    });
    els.switchBtn.addEventListener('click', function () { startCamera(currentFacingMode === 'user' ? 'environment' : 'user'); });
    els.cancelBtn.addEventListener('click', function () { stopCamera(); showState('consent'); });

    els.captureBtn.addEventListener('click', function () {
      var video = els.video;
      var canvas = els.capturedCanvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      var ctx = canvas.getContext('2d');
      if (currentFacingMode === 'user') { ctx.translate(canvas.width, 0); ctx.scale(-1, 1); }
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      stopCamera();
      lastSourceWasGallery = false;
      saveSharedPhoto(canvas.toDataURL('image/jpeg', 0.9));
      showState('captured');
    });

    els.retakeBtn.addEventListener('click', function () { if (lastSourceWasGallery) showState('consent'); else startCamera(currentFacingMode); });
    els.retakeResultBtn.addEventListener('click', function () { if (lastSourceWasGallery) showState('consent'); else startCamera(currentFacingMode); });
    els.startOverBtn.addEventListener('click', function () { showState('pickTop'); });

    els.downloadBtn.addEventListener('click', function () {
      var src = els.resultImg.src;
      if (!src) return;
      var mimeMatch = /^data:image\/(\w+);/.exec(src);
      var ext = mimeMatch ? mimeMatch[1].replace('jpeg', 'jpg') : 'png';
      var a = document.createElement('a');
      a.href = src;
      a.download = 'bliss-outfit-' + Date.now() + '.' + ext;
      document.body.appendChild(a);
      a.click();
      a.remove();
    });

    els.addToCartBtn.addEventListener('click', function () {
      if (!selectedTopVariant || !selectedBottomVariant) return;
      els.addToCartBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedTopVariant.id, quantity: 1 }, { id: selectedBottomVariant.id, quantity: 1 }] }),
      })
        .then(function (r) { if (!r.ok) throw new Error('add to cart failed'); return r.json(); })
        .then(function () {
          els.cartMsg.textContent = 'Added both to cart! ';
          var link = document.createElement('a');
          link.href = '/cart';
          link.textContent = 'View cart →';
          link.style.color = '#7C5CC4';
          link.style.marginLeft = '4px';
          els.cartMsg.appendChild(link);
          els.cartMsg.hidden = false;
        })
        .catch(function () {
          els.cartMsg.textContent = 'Could not add to cart. Please try again.';
          els.cartMsg.hidden = false;
        })
        .finally(function () { els.addToCartBtn.disabled = false; });
    });

    els.errorRetryBtn.addEventListener('click', function () { showState(lastErrorRetryState); });
    els.starRating.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn || !els.starRating.contains(btn)) return;
      var val = parseInt(btn.getAttribute('data-star'), 10);
      if (!val) return;
      submitFeedback(val);
    });

    function callTryOn(photoDataUrl, garmentImageUrl, garmentType) {
      return fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ photo: photoDataUrl, garmentImageUrl: garmentImageUrl, garmentType: garmentType }),
      }).then(function (resp) {
        return resp.json().catch(function () { return {}; }).then(function (data) {
          if (!resp.ok) throw new Error((data && (data.error || data.detail)) || ('Request failed (' + resp.status + ')'));
          if (!data || !data.image) throw new Error('No image returned by the server.');
          return data;
        });
      });
    }

    function generateOutfit() {
      showState('generating');
      els.generatingText.textContent = 'Adding your bottom…';
      var startPhoto = els.capturedCanvas.toDataURL('image/jpeg', 0.9);
      lastInputImageDataUrl = startPhoto;
      saveSharedPhoto(startPhoto);
      var totalElapsed = 0;
      secondPassRetried = false;

      callTryOn(startPhoto, productImageUrl(selectedBottom), 'bottom')
        .then(function (bottomData) {
          totalElapsed += (typeof bottomData.elapsedMs === 'number' ? bottomData.elapsedMs : 0);
          els.generatingText.textContent = 'Adding your top…';
          return runSecondPass(bottomData.image, totalElapsed);
        })
        .catch(function (e) {
          showError('Could not generate the outfit (' + (e && e.message ? e.message : 'unknown error') + ').', 'captured');
        });
    }

    function runSecondPass(bottomResultImage, totalElapsedSoFar) {
      return callTryOn(bottomResultImage, productImageUrl(selectedTop), 'top')
        .then(function (topData) {
          var totalElapsed = totalElapsedSoFar + (typeof topData.elapsedMs === 'number' ? topData.elapsedMs : 0);
          els.resultImg.src = topData.image;
          lastOutputImageDataUrl = topData.image;
          lastGenerationElapsedMs = totalElapsed;
          currentSessionId = makeSessionId();
          logSession();
          resetFeedbackUI();
          showState('result');
        })
        .catch(function (e) {
          if (!secondPassRetried) {
            secondPassRetried = true;
            els.generatingText.textContent = 'Still adding your top…';
            return runSecondPass(bottomResultImage, totalElapsedSoFar);
          }
          showError("Couldn't generate the full outfit (" + (e && e.message ? e.message : 'unknown error') + '). Please try again.', 'captured');
        });
    }

    els.generateBtn.addEventListener('click', generateOutfit);

    els.searchTop.addEventListener('input', function () { renderList(els.listTop, topProducts, els.searchTop.value, pickTop); });
    els.searchBottom.addEventListener('input', function () { renderList(els.listBottom, bottomProducts, els.searchBottom.value, pickBottom); });

    loadCollection(TOP_COLLECTION_URL, function (p) { topProducts = p; }, els.listTop);
    loadCollection(BOTTOM_COLLECTION_URL, function (p) { bottomProducts = p; }, els.listBottom);
    window.addEventListener('beforeunload', stopCamera);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ai-feature-pairing"] && !Shopify.designMode) return;
  try {
    (function () {
    var TOP_COLLECTION_URL = '/collections/top-wear/products.json?limit=250';
    var BOTTOM_COLLECTION_URL = '/collections/bottom-wear/products.json?limit=250';
    var PROXY_URL = 'https://bliss-tryon-proxy.vercel.app/api/tryon';
    var ANALYZE_URL = 'https://bliss-tryon-proxy.vercel.app/api/pairing-analyze';
    var FEEDBACK_URL = 'https://bliss-tryon-proxy.vercel.app/api/feedback';
    var HEIC2ANY_URL = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
    var MAX_UPLOAD_DIM = 1440;
    var SHARED_PHOTO_KEY = 'blissAiFeaturesPhoto';

    function id(name) { return document.getElementById(name); }
    var els = {
      resultBackBtn: id('afs3ResultBackBtn'),
      topCard: id('afs3TopCard'),
      bottomCard: id('afs3BottomCard'),
      sizeOptionsTop: id('afs3SizeOptionsTop'),
      sizeOptionsBottom: id('afs3SizeOptionsBottom'),
      addToCartBtn: id('afs3AddToCartBtn'),
      cartMsg: id('afs3CartMsg'),
      showAnotherBtn: id('afs3ShowAnotherBtn'),
      tryItOnBtn: id('afs3TryItOnBtn'),
      reuseBlock: id('afs3ReuseBlock'),
      reuseThumb: id('afs3ReuseThumb'),
      reuseUseBtn: id('afs3ReuseUseBtn'),
      reuseNewBtn: id('afs3ReuseNewBtn'),
      newPhotoBlock: id('afs3NewPhotoBlock'),
      consentCheck: id('afs3ConsentCheck'),
      startBtn: id('afs3StartBtn'),
      galleryBtn: id('afs3GalleryBtn'),
      galleryBtn2: id('afs3GalleryBtn2'),
      galleryInput: id('afs3GalleryInput'),
      galleryContinueBtn: id('afs3GalleryContinueBtn'),
      galleryTipBackBtn: id('afs3GalleryTipBackBtn'),
      video: id('afs3Video'),
      switchBtn: id('afs3SwitchBtn'),
      captureBtn: id('afs3CaptureBtn'),
      cancelBtn: id('afs3CancelBtn'),
      capturedCanvas: id('afs3CapturedCanvas'),
      retakeBtn: id('afs3RetakeBtn'),
      generateBtn: id('afs3GenerateBtn'),
      generatingText: id('afs3GeneratingText'),
      resultImg: id('afs3ResultImg'),
      downloadBtn: id('afs3DownloadBtn'),
      backToResultBtn: id('afs3BackToResultBtn'),
      errorText: id('afs3ErrorText'),
      errorRetryBtn: id('afs3ErrorRetryBtn'),
      states: {
        consent: id('afs3StateConsent'),
        galleryTip: id('afs3StateGalleryTip'),
        live: id('afs3StateLive'),
        captured: id('afs3StateCaptured'),
        generating: id('afs3StateGenerating'),
        result: id('afs3StateResult'),
        rendered: id('afs3StateRendered'),
        error: id('afs3StateError'),
      }
    };
    if (!els.generateBtn) return;

    function showState(name) { Object.keys(els.states).forEach(function (k) { els.states[k].hidden = (k !== name); }); }

    var answers = { build: null, fit: null, style: null, tone: null };
    var topProducts = [], bottomProducts = [];
    var lastTopMatches = [], lastBottomMatches = [];
    var matchIndex = 0;
    var selectedTop = null, selectedBottom = null;
    var selectedTopVariant = null, selectedBottomVariant = null;
    var currentStream = null, currentFacingMode = 'user', availableCameraCount = 1;
    var lastErrorRetryState = 'captured';
    var lastSourceWasGallery = false, heicFallbackAttempted = false, preGalleryTipState = 'consent';
    var secondPassRetried = false;

    function productImageUrl(product) {
      var src = product.images && product.images[0] && product.images[0].src;
      if (!src) return '';
      if (src.indexOf('://') === -1) src = 'https:' + src;
      return src;
    }

    function loadCollections(cb) {
      Promise.all([
        fetch(TOP_COLLECTION_URL).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }),
        fetch(BOTTOM_COLLECTION_URL).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }),
      ]).then(function (results) {
        topProducts = (results[0].products || []).filter(function (p) { return p.images && p.images.length && p.variants && p.variants.length; });
        bottomProducts = (results[1].products || []).filter(function (p) { return p.images && p.images.length && p.variants && p.variants.length; });
        cb();
      });
    }

    var FIT_WORDS = { slim: ['slim'], regular: ['regular', 'straight'], baggy: ['baggy', 'relaxed', 'wide'] };
    var STYLE_WORDS = { minimal: ['regular', 'gabardine', 'clean'], streetwear: ['baggy', 'denim', 'track'], bold: ['baggy', 'bleach', 'wash'] };
    var TONE_WORDS = {
      light: ['ivory', 'azure', 'sky', 'white', 'dust', 'frost'],
      medium: ['clay', 'dawn', 'dusky', 'bluverse'],
      dark: ['obscuro', 'void', 'midnight', 'smokenite', 'black'],
    };

    function scoreProduct(product) {
      var title = (product.title || '').toLowerCase();
      var score = 0;
      (FIT_WORDS[answers.fit] || []).forEach(function (w) { if (title.indexOf(w) !== -1) score += 3; });
      (STYLE_WORDS[answers.style] || []).forEach(function (w) { if (title.indexOf(w) !== -1) score += 2; });
      if (answers.tone) { (TONE_WORDS[answers.tone] || []).forEach(function (w) { if (title.indexOf(w) !== -1) score += 1; }); }
      if (answers.build === 'slim' && title.indexOf('slim') !== -1) score += 1;
      if (answers.build === 'full' && (title.indexOf('baggy') !== -1 || title.indexOf('relaxed') !== -1)) score += 1;
      return score;
    }

    function rankedMatches(products) {
      return products.map(function (p) { return { product: p, score: scoreProduct(p) }; })
        .sort(function (a, b) { return b.score - a.score; })
        .map(function (m) { return m.product; });
    }

    function renderPairCard(container, product, sizeContainer) {
      container.innerHTML = '';
      var img = document.createElement('img');
      img.src = productImageUrl(product);
      img.alt = product.title;
      var title = document.createElement('div');
      title.className = 'afs3-pair-card-title';
      title.textContent = product.title;
      var price = document.createElement('div');
      price.className = 'afs3-pair-card-price';
      var firstVariant = product.variants && product.variants[0];
      price.textContent = firstVariant ? ('Tk ' + firstVariant.price) : '';
      container.appendChild(img);
      container.appendChild(title);
      container.appendChild(price);

      sizeContainer.innerHTML = '';
      var selectedVariant = null;
      (product.variants || []).forEach(function (variant) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'afs3-size-btn';
        btn.textContent = variant.title;
        btn.setAttribute('aria-pressed', 'false');
        if (!variant.available) {
          var flag = document.createElement('span');
          flag.className = 'afs3-pair-card-stock';
        }
        btn.addEventListener('click', function () {
          sizeContainer.querySelectorAll('.afs3-size-btn').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          if (sizeContainer === els.sizeOptionsTop) selectedTopVariant = variant; else selectedBottomVariant = variant;
          if (!variant.available) {
            var note = document.createElement('p');
            note.className = 'afs3-pair-card-stock';
            note.textContent = 'Out of stock in this size right now.';
            var existing = container.querySelector('.afs3-pair-card-stock');
            if (existing) existing.remove();
            container.appendChild(note);
          } else {
            var existing2 = container.querySelector('.afs3-pair-card-stock');
            if (existing2) existing2.remove();
          }
          checkCartReady();
        });
        sizeContainer.appendChild(btn);
      });
    }

    function checkCartReady() { els.addToCartBtn.disabled = !(selectedTopVariant && selectedBottomVariant); }

    function showPairing() {
      selectedTopVariant = null; selectedBottomVariant = null;
      els.cartMsg.hidden = true;
      checkCartReady();
      selectedTop = lastTopMatches[matchIndex % lastTopMatches.length];
      selectedBottom = lastBottomMatches[matchIndex % lastBottomMatches.length];
      renderPairCard(els.topCard, selectedTop, els.sizeOptionsTop);
      renderPairCard(els.bottomCard, selectedBottom, els.sizeOptionsBottom);
      showState('result');
    }

    function findPairingFromAnswers() {
      loadCollections(function () {
        lastTopMatches = rankedMatches(topProducts);
        lastBottomMatches = rankedMatches(bottomProducts);
        matchIndex = 0;
        if (!lastTopMatches.length || !lastBottomMatches.length) {
          showError('Not enough products available to build a pairing right now. Please check back soon.', 'captured');
          return;
        }
        showPairing();
      });
    }

    function analyzeForPairing() {
      showState('generating');
      els.generatingText.textContent = 'Analyzing your photo…';
      var photoDataUrl = els.capturedCanvas.toDataURL('image/jpeg', 0.9);
      saveSharedPhoto(photoDataUrl);
      fetch(ANALYZE_URL, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ photo: photoDataUrl }),
      })
        .then(function (resp) {
          return resp.json().catch(function () { return {}; }).then(function (data) {
            if (!resp.ok) throw new Error((data && (data.error || data.detail)) || ('Request failed (' + resp.status + ')'));
            return data;
          });
        })
        .then(function (data) {
          answers.build = data.build || 'regular';
          answers.fit = data.fit || 'regular';
          answers.style = data.style || 'minimal';
          answers.tone = data.tone || null;
          els.generatingText.textContent = 'Finding your pairing…';
          findPairingFromAnswers();
        })
        .catch(function (e) {
          showError('Could not analyze your photo (' + (e && e.message ? e.message : 'unknown error') + '). Please try again.', 'captured');
        });
    }

    els.resultBackBtn.addEventListener('click', function () { showState('consent'); initEntry(); });
    els.showAnotherBtn.addEventListener('click', function () {
      matchIndex = (matchIndex + 1) % Math.max(lastTopMatches.length, lastBottomMatches.length, 1);
      showPairing();
    });

    els.addToCartBtn.addEventListener('click', function () {
      if (!selectedTopVariant || !selectedBottomVariant) return;
      els.addToCartBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedTopVariant.id, quantity: 1 }, { id: selectedBottomVariant.id, quantity: 1 }] }),
      })
        .then(function (r) { if (!r.ok) throw new Error('add to cart failed'); return r.json(); })
        .then(function () {
          els.cartMsg.textContent = 'Added both to cart! ';
          var link = document.createElement('a');
          link.href = '/cart'; link.textContent = 'View cart →'; link.style.color = '#7C5CC4'; link.style.marginLeft = '4px';
          els.cartMsg.appendChild(link);
          els.cartMsg.hidden = false;
        })
        .catch(function () { els.cartMsg.textContent = 'Could not add to cart. Please try again.'; els.cartMsg.hidden = false; })
        .finally(function () { els.addToCartBtn.disabled = false; });
    });

    function sharedPhoto() { try { return sessionStorage.getItem(SHARED_PHOTO_KEY); } catch (e) { return null; } }
    function saveSharedPhoto(dataUrl) { try { sessionStorage.setItem(SHARED_PHOTO_KEY, dataUrl); } catch (e) {} }

    function initEntry() {
      var existing = sharedPhoto();
      if (existing) {
        els.reuseBlock.hidden = false;
        els.reuseThumb.src = existing;
        els.newPhotoBlock.hidden = true;
      } else {
        els.reuseBlock.hidden = true;
        els.newPhotoBlock.hidden = false;
      }
      els.consentCheck.checked = false;
      els.startBtn.disabled = true;
      els.galleryBtn.disabled = true;
    }

    els.tryItOnBtn.addEventListener('click', function () { generateOutfit(); });

    els.reuseUseBtn.addEventListener('click', function () {
      var img = new Image();
      img.onload = function () {
        var canvas = els.capturedCanvas;
        canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
        canvas.getContext('2d').drawImage(img, 0, 0);
        showState('captured');
      };
      img.src = sharedPhoto();
    });
    els.reuseNewBtn.addEventListener('click', function () { els.reuseBlock.hidden = true; els.newPhotoBlock.hidden = false; });

    function stopCamera() { if (currentStream) { currentStream.getTracks().forEach(function (t) { t.stop(); }); currentStream = null; } }
    function cameraErrorMessage(e) {
      if (e && e.name === 'NotAllowedError') return "Camera access was denied. You can allow it from your browser's site settings, or choose a photo from your gallery instead.";
      if (e && e.name === 'NotFoundError') return 'No camera was found on this device. You can choose a photo from your gallery instead.';
      return 'Could not access the camera (' + (e && e.message ? e.message : 'unknown error') + '). You can choose a photo from your gallery instead.';
    }
    function showError(msg, retryState) { stopCamera(); els.errorText.textContent = msg; lastErrorRetryState = retryState || 'captured'; showState('error'); }
    function countCameras() {
      return navigator.mediaDevices.enumerateDevices().then(function (devices) {
        availableCameraCount = devices.filter(function (d) { return d.kind === 'videoinput'; }).length;
      }).catch(function () { availableCameraCount = 1; });
    }
    function startCamera(facingMode) {
      stopCamera();
      return navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: facingMode }, width: { ideal: 1280 }, height: { ideal: 1280 } }, audio: false })
        .then(function (stream) {
          currentStream = stream; currentFacingMode = facingMode;
          els.video.srcObject = stream;
          els.video.style.transform = facingMode === 'user' ? 'scaleX(-1)' : 'none';
          return countCameras();
        }).then(function () { els.switchBtn.hidden = availableCameraCount < 2; showState('live'); })
        .catch(function (e) { showError(cameraErrorMessage(e), 'consent'); });
    }
    function looksLikeHeic(file) {
      var name = (file.name || '').toLowerCase(); var type = (file.type || '').toLowerCase();
      return type.indexOf('heic') !== -1 || type.indexOf('heif') !== -1 || name.endsWith('.heic') || name.endsWith('.heif');
    }
    function ensureHeic2any() {
      if (window.heic2any) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script'); s.src = HEIC2ANY_URL;
        s.onload = function () { resolve(); }; s.onerror = function () { reject(new Error('Could not load photo converter')); };
        document.head.appendChild(s);
      });
    }
    function loadBlobIntoCanvas(blob) {
      var reader = new FileReader();
      reader.onload = function () {
        var img = new Image();
        img.onload = function () {
          stopCamera();
          var w = img.naturalWidth, h = img.naturalHeight;
          if (w > MAX_UPLOAD_DIM || h > MAX_UPLOAD_DIM) {
            if (w >= h) { h = Math.round(h * MAX_UPLOAD_DIM / w); w = MAX_UPLOAD_DIM; } else { w = Math.round(w * MAX_UPLOAD_DIM / h); h = MAX_UPLOAD_DIM; }
          }
          var canvas = els.capturedCanvas; canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          lastSourceWasGallery = true; showState('captured');
        };
        img.onerror = function () { tryHeicFallback(blob); };
        img.src = reader.result;
      };
      reader.onerror = function () { showError('Could not read that file. Please try again.', 'consent'); };
      reader.readAsDataURL(blob);
    }
    function convertHeicAndLoad(file) {
      showState('generating'); els.generatingText.textContent = 'Preparing your photo…';
      ensureHeic2any().then(function () { return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 }); })
        .then(function (converted) { loadBlobIntoCanvas(Array.isArray(converted) ? converted[0] : converted); })
        .catch(function () { showError('This photo format (HEIC) could not be converted. Please try a different photo, or use the camera instead.', 'consent'); });
    }
    function tryHeicFallback(blob) {
      if (heicFallbackAttempted) { showError('Could not read that image. Please try a different photo.', 'consent'); return; }
      heicFallbackAttempted = true; convertHeicAndLoad(blob);
    }
    function processFile(file) { if (looksLikeHeic(file)) { convertHeicAndLoad(file); } else { loadBlobIntoCanvas(file); } }
    function loadImageFromFile(file) {
      if (!file) return;
      var type = (file.type || '').toLowerCase();
      if (type.indexOf('image/') !== 0 && !looksLikeHeic(file)) { showError('Please choose an image file.', 'consent'); return; }
      heicFallbackAttempted = false; processFile(file);
    }
    els.consentCheck.addEventListener('change', function () { els.startBtn.disabled = !els.consentCheck.checked; els.galleryBtn.disabled = !els.consentCheck.checked; });
    els.startBtn.addEventListener('click', function () { lastSourceWasGallery = false; startCamera(currentFacingMode); });
    function openGalleryTip(fromState) { preGalleryTipState = fromState; if (fromState === 'live') stopCamera(); showState('galleryTip'); }
    els.galleryBtn.addEventListener('click', function () { openGalleryTip('consent'); });
    els.galleryBtn2.addEventListener('click', function () { openGalleryTip('live'); });
    els.galleryContinueBtn.addEventListener('click', function () { els.galleryInput.click(); });
    els.galleryTipBackBtn.addEventListener('click', function () { if (preGalleryTipState === 'live') startCamera(currentFacingMode); else showState('consent'); });
    els.galleryInput.addEventListener('change', function (e) { var file = e.target.files && e.target.files[0]; loadImageFromFile(file); els.galleryInput.value = ''; });
    els.switchBtn.addEventListener('click', function () { startCamera(currentFacingMode === 'user' ? 'environment' : 'user'); });
    els.cancelBtn.addEventListener('click', function () { stopCamera(); showState('consent'); });
    els.captureBtn.addEventListener('click', function () {
      var video = els.video, canvas = els.capturedCanvas;
      canvas.width = video.videoWidth; canvas.height = video.videoHeight;
      var ctx = canvas.getContext('2d');
      if (currentFacingMode === 'user') { ctx.translate(canvas.width, 0); ctx.scale(-1, 1); }
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      stopCamera(); lastSourceWasGallery = false; showState('captured');
    });
    els.retakeBtn.addEventListener('click', function () { if (lastSourceWasGallery) showState('consent'); else startCamera(currentFacingMode); });
    els.generateBtn.addEventListener('click', analyzeForPairing);
    els.backToResultBtn.addEventListener('click', function () { showState('result'); });
    els.downloadBtn.addEventListener('click', function () {
      var src = els.resultImg.src; if (!src) return;
      var mimeMatch = /^data:image\/(\w+);/.exec(src);
      var ext = mimeMatch ? mimeMatch[1].replace('jpeg', 'jpg') : 'png';
      var a = document.createElement('a'); a.href = src; a.download = 'bliss-pairing-' + Date.now() + '.' + ext;
      document.body.appendChild(a); a.click(); a.remove();
    });
    els.errorRetryBtn.addEventListener('click', function () { showState(lastErrorRetryState); });

    function callTryOn(photoDataUrl, garmentImageUrl, garmentType) {
      return fetch(PROXY_URL, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ photo: photoDataUrl, garmentImageUrl: garmentImageUrl, garmentType: garmentType }),
      }).then(function (resp) {
        return resp.json().catch(function () { return {}; }).then(function (data) {
          if (!resp.ok) throw new Error((data && (data.error || data.detail)) || ('Request failed (' + resp.status + ')'));
          if (!data || !data.image) throw new Error('No image returned by the server.');
          return data;
        });
      });
    }

    function logSession(inputImg, outputImg, elapsedMs) {
      var sessionId = 'pairing-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      fetch(FEEDBACK_URL, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: sessionId, garmentType: 'outfit',
          productHandle: selectedTop.handle + '+' + selectedBottom.handle,
          elapsedMs: elapsedMs, inputImage: inputImg, outputImage: outputImg, sessionType: 'pairing',
        }),
      }).catch(function () {});
    }

    function generateOutfit() {
      showState('generating'); els.generatingText.textContent = 'Adding your bottom…';
      var startPhoto = els.capturedCanvas.toDataURL('image/jpeg', 0.9);
      saveSharedPhoto(startPhoto);
      var totalElapsed = 0; secondPassRetried = false;
      callTryOn(startPhoto, productImageUrl(selectedBottom), 'bottom')
        .then(function (bottomData) {
          totalElapsed += (typeof bottomData.elapsedMs === 'number' ? bottomData.elapsedMs : 0);
          els.generatingText.textContent = 'Adding your top…';
          return runSecondPass(bottomData.image, totalElapsed, startPhoto);
        })
        .catch(function (e) { showError('Could not generate the outfit (' + (e && e.message ? e.message : 'unknown error') + ').', 'captured'); });
    }
    function runSecondPass(bottomResultImage, totalElapsedSoFar, startPhoto) {
      return callTryOn(bottomResultImage, productImageUrl(selectedTop), 'top')
        .then(function (topData) {
          var totalElapsed = totalElapsedSoFar + (typeof topData.elapsedMs === 'number' ? topData.elapsedMs : 0);
          els.resultImg.src = topData.image;
          logSession(startPhoto, topData.image, totalElapsed);
          showState('rendered');
        })
        .catch(function (e) {
          if (!secondPassRetried) { secondPassRetried = true; els.generatingText.textContent = 'Still adding your top…'; return runSecondPass(bottomResultImage, totalElapsedSoFar, startPhoto); }
          showError("Couldn't generate the full outfit (" + (e && e.message ? e.message : 'unknown error') + '). Please try again.', 'captured');
        });
    }
    window.addEventListener('beforeunload', stopCamera);

    initEntry();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ai-feature-single"] && !Shopify.designMode) return;
  try {
    (function () {
    var PRODUCTS_URL = '/products.json?limit=250';
    var PROXY_URL = 'https://bliss-tryon-proxy.vercel.app/api/tryon';
    var FEEDBACK_URL = 'https://bliss-tryon-proxy.vercel.app/api/feedback';
    var HEIC2ANY_URL = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
    var MAX_UPLOAD_DIM = 1440;

    function id(name) { return document.getElementById(name); }

    var els = {
      searchInput: id('afs1SearchInput'),
      productList: id('afs1ProductList'),
      sizeBackBtn: id('afs1SizeBackBtn'),
      sizePreview: id('afs1SizeProductPreview'),
      sizeOptions: id('afs1SizeOptions'),
      sizeContinueBtn: id('afs1SizeContinueBtn'),
      consentBackBtn: id('afs1ConsentBackBtn'),
      consentCheck: id('afs1ConsentCheck'),
      startBtn: id('afs1StartBtn'),
      galleryBtn: id('afs1GalleryBtn'),
      galleryBtn2: id('afs1GalleryBtn2'),
      galleryInput: id('afs1GalleryInput'),
      galleryContinueBtn: id('afs1GalleryContinueBtn'),
      galleryTipBackBtn: id('afs1GalleryTipBackBtn'),
      video: id('afs1Video'),
      switchBtn: id('afs1SwitchBtn'),
      captureBtn: id('afs1CaptureBtn'),
      cancelBtn: id('afs1CancelBtn'),
      capturedCanvas: id('afs1CapturedCanvas'),
      retakeBtn: id('afs1RetakeBtn'),
      generateBtn: id('afs1GenerateBtn'),
      generatingText: id('afs1GeneratingText'),
      resultImg: id('afs1ResultImg'),
      addToCartBtn: id('afs1AddToCartBtn'),
      cartMsg: id('afs1CartMsg'),
      downloadBtn: id('afs1DownloadBtn'),
      feedbackRow: id('afs1FeedbackRow'),
      starRating: id('afs1StarRating'),
      feedbackThanks: id('afs1FeedbackThanks'),
      retakeResultBtn: id('afs1RetakeResultBtn'),
      startOverBtn: id('afs1StartOverBtn'),
      errorText: id('afs1ErrorText'),
      errorRetryBtn: id('afs1ErrorRetryBtn'),
      states: {
        picker: id('afs1StatePicker'),
        size: id('afs1StateSize'),
        consent: id('afs1StateConsent'),
        galleryTip: id('afs1StateGalleryTip'),
        live: id('afs1StateLive'),
        captured: id('afs1StateCaptured'),
        generating: id('afs1StateGenerating'),
        result: id('afs1StateResult'),
        error: id('afs1StateError'),
      }
    };

    if (!els.searchInput) return; // snippet not on this page

    function showState(name) {
      Object.keys(els.states).forEach(function (k) { els.states[k].hidden = (k !== name); });
    }

    var allProducts = [];
    var selectedProduct = null;
    var selectedVariant = null;
    var currentStream = null;
    var currentFacingMode = 'user';
    var availableCameraCount = 1;
    var lastErrorRetryState = 'picker';
    var lastSourceWasGallery = false;
    var heicFallbackAttempted = false;
    var preGalleryTipState = 'consent';
    var lastGenerationElapsedMs = null;
    var feedbackSubmitted = false;
    var currentSessionId = null;
    var lastInputImageDataUrl = null;
    var lastOutputImageDataUrl = null;

    function garmentTypeFor(product) {
      var t = (product.product_type || '').toLowerCase();
      if (t.indexOf('bottom') !== -1 || t.indexOf('pant') !== -1 || t.indexOf('short') !== -1 || t.indexOf('jean') !== -1 || t.indexOf('trouser') !== -1 || t.indexOf('gabardine') !== -1 || t.indexOf('jogger') !== -1) return 'bottom';
      if (t.indexOf('top') !== -1 || t.indexOf('shirt') !== -1 || t.indexOf('jacket') !== -1 || t.indexOf('hoodie') !== -1 || t.indexOf('jersey') !== -1 || t.indexOf('sweater') !== -1 || t.indexOf('sweatshirt') !== -1 || t.indexOf('outerwear') !== -1 || t.indexOf('polo') !== -1 || t.indexOf('tee') !== -1) return 'top';
      return 'generic';
    }

    function productImageUrl(product) {
      var src = product.images && product.images[0] && product.images[0].src;
      if (!src) return '';
      if (src.indexOf('://') === -1) src = 'https:' + src;
      return src;
    }

    function renderProductList(filterText) {
      var q = (filterText || '').trim().toLowerCase();
      var filtered = !q ? allProducts : allProducts.filter(function (p) { return p.title.toLowerCase().indexOf(q) !== -1; });
      els.productList.innerHTML = '';
      if (!filtered.length) {
        var empty = document.createElement('p');
        empty.className = 'afs1-empty-text';
        empty.textContent = 'No products found.';
        els.productList.appendChild(empty);
        return;
      }
      filtered.slice(0, 60).forEach(function (product) {
        var item = document.createElement('div');
        item.className = 'afs1-product-item';
        var img = document.createElement('img');
        img.src = productImageUrl(product);
        img.alt = product.title;
        img.loading = 'lazy';
        var info = document.createElement('div');
        info.className = 'afs1-product-item-info';
        var title = document.createElement('span');
        title.className = 'afs1-product-item-title';
        title.textContent = product.title;
        var price = document.createElement('span');
        price.className = 'afs1-product-item-price';
        var firstVariant = product.variants && product.variants[0];
        price.textContent = firstVariant ? ('Tk ' + firstVariant.price) : '';
        info.appendChild(title);
        info.appendChild(price);
        item.appendChild(img);
        item.appendChild(info);
        item.addEventListener('click', function () { selectProduct(product); });
        els.productList.appendChild(item);
      });
    }

    function loadProducts() {
      fetch(PRODUCTS_URL)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          allProducts = (data.products || []).filter(function (p) { return p.images && p.images.length; });
          renderProductList('');
        })
        .catch(function () {
          els.productList.innerHTML = '<p class="afs1-empty-text">Could not load products. Please refresh and try again.</p>';
        });
    }

    function selectProduct(product) {
      selectedProduct = product;
      selectedVariant = null;
      els.sizePreview.innerHTML = '';
      var img = document.createElement('img');
      img.src = productImageUrl(product);
      img.alt = product.title;
      var infoWrap = document.createElement('div');
      var titleEl = document.createElement('div');
      titleEl.className = 'afs1-size-preview-title';
      titleEl.textContent = product.title;
      var priceEl = document.createElement('div');
      priceEl.className = 'afs1-size-preview-price';
      var firstVariant = product.variants && product.variants[0];
      priceEl.textContent = firstVariant ? ('Tk ' + firstVariant.price) : '';
      infoWrap.appendChild(titleEl);
      infoWrap.appendChild(priceEl);
      els.sizePreview.appendChild(img);
      els.sizePreview.appendChild(infoWrap);

      els.sizeOptions.innerHTML = '';
      (product.variants || []).forEach(function (variant) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'afs1-size-btn';
        btn.textContent = variant.title;
        btn.setAttribute('aria-pressed', 'false');
        if (!variant.available) btn.disabled = true;
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          selectedVariant = variant;
          Array.prototype.forEach.call(els.sizeOptions.querySelectorAll('.afs1-size-btn'), function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          els.sizeContinueBtn.disabled = false;
        });
        els.sizeOptions.appendChild(btn);
      });
      showState('size');
    }

    els.sizeBackBtn.addEventListener('click', function () { showState('picker'); });
    els.sizeContinueBtn.addEventListener('click', function () {
      if (!selectedVariant) return;
      showState('consent');
      els.consentCheck.checked = false;
      els.startBtn.disabled = true;
      els.galleryBtn.disabled = true;
    });
    els.consentBackBtn.addEventListener('click', function () { showState('size'); });

    function resetFeedbackUI() {
      feedbackSubmitted = false;
      els.feedbackRow.hidden = false;
      els.feedbackThanks.hidden = true;
      els.cartMsg.hidden = true;
    }

    function makeSessionId() {
      return (selectedProduct ? selectedProduct.handle : 'single') + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    }

    function logSession() {
      fetch(FEEDBACK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: currentSessionId,
          garmentType: garmentTypeFor(selectedProduct),
          productHandle: selectedProduct.handle,
          elapsedMs: lastGenerationElapsedMs,
          inputImage: lastInputImageDataUrl,
          outputImage: lastOutputImageDataUrl,
          sessionType: 'single',
        }),
      }).catch(function () {});
    }

    function submitFeedback(rating) {
      if (feedbackSubmitted) return;
      feedbackSubmitted = true;
      els.feedbackRow.hidden = true;
      els.feedbackThanks.hidden = false;
      fetch(FEEDBACK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: currentSessionId,
          rating: rating,
          garmentType: garmentTypeFor(selectedProduct),
          productHandle: selectedProduct.handle,
          elapsedMs: lastGenerationElapsedMs,
          sessionType: 'single',
        }),
      }).catch(function () {});
    }

    function stopCamera() {
      if (currentStream) {
        currentStream.getTracks().forEach(function (t) { t.stop(); });
        currentStream = null;
      }
    }

    function cameraErrorMessage(e) {
      if (e && e.name === 'NotAllowedError') return "Camera access was denied. You can allow it from your browser's site settings, or choose a photo from your gallery instead.";
      if (e && e.name === 'NotFoundError') return 'No camera was found on this device. You can choose a photo from your gallery instead.';
      return 'Could not access the camera (' + (e && e.message ? e.message : 'unknown error') + '). You can choose a photo from your gallery instead.';
    }

    function showError(msg, retryState) {
      stopCamera();
      els.errorText.textContent = msg;
      lastErrorRetryState = retryState || 'picker';
      showState('error');
    }

    function countCameras() {
      return navigator.mediaDevices.enumerateDevices().then(function (devices) {
        availableCameraCount = devices.filter(function (d) { return d.kind === 'videoinput'; }).length;
      }).catch(function () { availableCameraCount = 1; });
    }

    function startCamera(facingMode) {
      stopCamera();
      return navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: facingMode }, width: { ideal: 1280 }, height: { ideal: 1280 } },
        audio: false
      }).then(function (stream) {
        currentStream = stream;
        currentFacingMode = facingMode;
        els.video.srcObject = stream;
        els.video.style.transform = facingMode === 'user' ? 'scaleX(-1)' : 'none';
        return countCameras();
      }).then(function () {
        els.switchBtn.hidden = availableCameraCount < 2;
        showState('live');
      }).catch(function (e) {
        showError(cameraErrorMessage(e), 'consent');
      });
    }

    function looksLikeHeic(file) {
      var name = (file.name || '').toLowerCase();
      var type = (file.type || '').toLowerCase();
      return type.indexOf('heic') !== -1 || type.indexOf('heif') !== -1 || name.endsWith('.heic') || name.endsWith('.heif');
    }

    function ensureHeic2any() {
      if (window.heic2any) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = HEIC2ANY_URL;
        s.onload = function () { resolve(); };
        s.onerror = function () { reject(new Error('Could not load photo converter')); };
        document.head.appendChild(s);
      });
    }

    function loadBlobIntoCanvas(blob) {
      var reader = new FileReader();
      reader.onload = function () {
        var img = new Image();
        img.onload = function () {
          stopCamera();
          var w = img.naturalWidth;
          var h = img.naturalHeight;
          if (w > MAX_UPLOAD_DIM || h > MAX_UPLOAD_DIM) {
            if (w >= h) { h = Math.round(h * MAX_UPLOAD_DIM / w); w = MAX_UPLOAD_DIM; }
            else { w = Math.round(w * MAX_UPLOAD_DIM / h); h = MAX_UPLOAD_DIM; }
          }
          var canvas = els.capturedCanvas;
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          lastSourceWasGallery = true;
          showState('captured');
        };
        img.onerror = function () { tryHeicFallback(blob); };
        img.src = reader.result;
      };
      reader.onerror = function () { showError('Could not read that file. Please try again.', 'consent'); };
      reader.readAsDataURL(blob);
    }

    function convertHeicAndLoad(file) {
      showState('generating');
      els.generatingText.textContent = 'Preparing your photo…';
      ensureHeic2any()
        .then(function () { return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 }); })
        .then(function (converted) { loadBlobIntoCanvas(Array.isArray(converted) ? converted[0] : converted); })
        .catch(function () { showError('This photo format (HEIC) could not be converted. Please try a different photo, or use the camera instead.', 'consent'); });
    }

    function tryHeicFallback(blob) {
      if (heicFallbackAttempted) { showError('Could not read that image. Please try a different photo.', 'consent'); return; }
      heicFallbackAttempted = true;
      convertHeicAndLoad(blob);
    }

    function processFile(file) {
      if (looksLikeHeic(file)) { convertHeicAndLoad(file); return; }
      loadBlobIntoCanvas(file);
    }

    function loadImageFromFile(file) {
      if (!file) return;
      var type = (file.type || '').toLowerCase();
      if (type.indexOf('image/') !== 0 && !looksLikeHeic(file)) { showError('Please choose an image file.', 'consent'); return; }
      heicFallbackAttempted = false;
      processFile(file);
    }

    els.consentCheck.addEventListener('change', function () {
      els.startBtn.disabled = !els.consentCheck.checked;
      els.galleryBtn.disabled = !els.consentCheck.checked;
    });
    els.startBtn.addEventListener('click', function () { lastSourceWasGallery = false; startCamera(currentFacingMode); });

    function openGalleryTip(fromState) {
      preGalleryTipState = fromState;
      if (fromState === 'live') stopCamera();
      showState('galleryTip');
    }
    els.galleryBtn.addEventListener('click', function () { openGalleryTip('consent'); });
    els.galleryBtn2.addEventListener('click', function () { openGalleryTip('live'); });
    els.galleryContinueBtn.addEventListener('click', function () { els.galleryInput.click(); });
    els.galleryTipBackBtn.addEventListener('click', function () {
      if (preGalleryTipState === 'live') startCamera(currentFacingMode); else showState('consent');
    });
    els.galleryInput.addEventListener('change', function (e) {
      var file = e.target.files && e.target.files[0];
      loadImageFromFile(file);
      els.galleryInput.value = '';
    });
    els.switchBtn.addEventListener('click', function () { startCamera(currentFacingMode === 'user' ? 'environment' : 'user'); });
    els.cancelBtn.addEventListener('click', function () { stopCamera(); showState('consent'); });

    els.captureBtn.addEventListener('click', function () {
      var video = els.video;
      var canvas = els.capturedCanvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      var ctx = canvas.getContext('2d');
      if (currentFacingMode === 'user') { ctx.translate(canvas.width, 0); ctx.scale(-1, 1); }
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      stopCamera();
      lastSourceWasGallery = false;
      showState('captured');
    });

    els.retakeBtn.addEventListener('click', function () { if (lastSourceWasGallery) showState('consent'); else startCamera(currentFacingMode); });
    els.retakeResultBtn.addEventListener('click', function () { if (lastSourceWasGallery) showState('consent'); else startCamera(currentFacingMode); });
    els.startOverBtn.addEventListener('click', function () { showState('picker'); });

    els.downloadBtn.addEventListener('click', function () {
      var src = els.resultImg.src;
      if (!src) return;
      var mimeMatch = /^data:image\/(\w+);/.exec(src);
      var ext = mimeMatch ? mimeMatch[1].replace('jpeg', 'jpg') : 'png';
      var a = document.createElement('a');
      a.href = src;
      a.download = 'bliss-tryon-' + (selectedProduct ? selectedProduct.handle : 'preview') + '-' + Date.now() + '.' + ext;
      document.body.appendChild(a);
      a.click();
      a.remove();
    });

    els.addToCartBtn.addEventListener('click', function () {
      if (!selectedVariant) return;
      els.addToCartBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity: 1 }] }),
      })
        .then(function (r) { if (!r.ok) throw new Error('add to cart failed'); return r.json(); })
        .then(function () {
          els.cartMsg.textContent = 'Added to cart! ';
          var link = document.createElement('a');
          link.href = '/cart';
          link.textContent = 'View cart →';
          link.style.color = '#7C5CC4';
          link.style.marginLeft = '4px';
          els.cartMsg.appendChild(link);
          els.cartMsg.hidden = false;
        })
        .catch(function () {
          els.cartMsg.textContent = 'Could not add to cart. Please try again.';
          els.cartMsg.hidden = false;
        })
        .finally(function () { els.addToCartBtn.disabled = false; });
    });

    els.errorRetryBtn.addEventListener('click', function () { showState(lastErrorRetryState); });
    els.starRating.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn || !els.starRating.contains(btn)) return;
      var val = parseInt(btn.getAttribute('data-star'), 10);
      if (!val) return;
      submitFeedback(val);
    });

    function generateTryOn() {
      showState('generating');
      els.generatingText.textContent = 'Creating your preview… this usually takes 5–8 seconds.';
      var photoDataUrl = els.capturedCanvas.toDataURL('image/jpeg', 0.9);
      lastInputImageDataUrl = photoDataUrl;
      fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ photo: photoDataUrl, garmentImageUrl: productImageUrl(selectedProduct), garmentType: garmentTypeFor(selectedProduct) }),
      })
        .then(function (resp) {
          return resp.json().catch(function () { return {}; }).then(function (data) {
            if (!resp.ok) throw new Error((data && (data.error || data.detail)) || ('Request failed (' + resp.status + ')'));
            if (!data || !data.image) throw new Error('No image returned by the server.');
            els.resultImg.src = data.image;
            lastOutputImageDataUrl = data.image;
            lastGenerationElapsedMs = typeof data.elapsedMs === 'number' ? data.elapsedMs : null;
            currentSessionId = makeSessionId();
            logSession();
            resetFeedbackUI();
            showState('result');
          });
        })
        .catch(function (e) {
          showError('Could not generate the preview (' + (e && e.message ? e.message : 'unknown error') + ').', 'captured');
        });
    }
    els.generateBtn.addEventListener('click', generateTryOn);

    els.searchInput.addEventListener('input', function () { renderProductList(els.searchInput.value); });

    loadProducts();
    window.addEventListener('beforeunload', stopCamera);
  })();
  } catch(e) { console.error(e); }
})();

})();
